import React from 'react';
import { Result } from 'antd';

const NotFound = () => (
    <Result
        status="404"
        title="Processing..."
        subTitle="Please be patient, it's currently being worked on ^^"
        // extra={<Button type="primary">Go Back</Button>}
    />
);

export default NotFound;
